import { createContext, useContext } from 'react';

import { VirtualizedTableContextProviderValue } from '../../types';

const VirtualizedTableContext = createContext({});
VirtualizedTableContext.displayName = 'VirtualizedTableContext';

export default VirtualizedTableContext;

export const useVirtualizedTableContext = (): VirtualizedTableContextProviderValue =>
    useContext(VirtualizedTableContext);
